import { Component, Input } from '@angular/core'
import { MinimizeTab } from '../../../../../Interfaces/MinimizeTab'
import { StateService } from '../../../../../services'

const BACKDROP_CSS_CLASS_OPEN = ['cdk-overlay-backdrop', 'cdk-overlay-dark-backdrop', 'cdk-overlay-backdrop-showing']

@Component({
	selector: 'atyl-minimize-tab',
	templateUrl: './tab.component.html',
	styleUrls: ['./tab.component.scss']
})
export class AtylMinimizeTabComponent {

	@Input() data: MinimizeTab
	constructor(
		private stateService: StateService
	) { }
	close(event: MouseEvent) {
		this.data.dialogRef.close()
		this.stateService.removeMinimizeTab(this.data)
	}
	maximize(event: MouseEvent) {
		BACKDROP_CSS_CLASS_OPEN.forEach(className => {
			this.data.backdropElement.classList.add(className)
		})
		this.data.dialogRef.removePanelClass('d-none')
		this.stateService.removeMinimizeTab(this.data)
	}

}
